export const availableTaxeNames = [
  {
    name: $localize`City tax`,
    description: $localize`Tax imposed by a governement`,
  },
  {
    description: $localize`Tax for environmental costs. Usually out of provider's control and sent to us as something about environment/ecology`,
    name: $localize`Eco tax`,
  },
  {
    description: $localize`Tax imposed by a governement`,
    name: $localize`Local tax`,
  },
  {
    name: $localize`Short stay tax`,
    description: $localize`Tax imposed by a governement`,
  },
  {
    description: $localize`Tax imposed by a governement`,
    name: $localize`Tourist tax`,
  },
  {
    description: $localize`VAT/MwSt/Sales tax. Any additional tax when buying/selling something`,
    name: $localize`Vat`,
  },
]
